<empro-spinner [show]="started" />
<div class="mb-4 flex bg-gray-100 rounded-2xl border p-4">
  <div class="flex flex-1">
    <empro-icon
      [name]="'chevron-left'"
      [solid]="false"
      [variant]="'secondary'"
      class="cursor-pointer mt-2 mr-4"
      (click)="back()"
      (keydown)="back()"
    />

    @if (currentView === MigrationCustomerView.VIEW && showEditButton) {
      <empro-icon
        [name]="'pencil-square'"
        [solid]="true"
        [variant]="'secondary'"
        class="cursor-pointer w-6 h-6 mt-2"
        (click)="currentView = MigrationCustomerView.EDIT"
        (keydown)="currentView = MigrationCustomerView.EDIT"
      />
    }

    @if (currentView === MigrationCustomerView.EDIT) {
      <empro-icon
        [name]="'pencil-square'"
        [solid]="true"
        [variant]="'secondary'"
        class="cursor-pointer w-6 h-6 mt-2"
        (click)="currentView = MigrationCustomerView.VIEW"
        (keydown)="currentView = MigrationCustomerView.VIEW"
      />
    }
  </div>
  <div class="flex flex-1 justify-end">
    <empro-button
      fill="solid"
      id="start-migration-button"
      (onClick)="startMigrationClicked()"
      type="submit"
      class="font-medium"
    >
      Migration starten
    </empro-button>
  </div>
</div>

@if (messageShow) {
  <div id="migrationCustomerDetailsAlertBox">
    <empro-alert-box
      class="mb-4"
      [message]="message"
      [variant]="messageType"
    />
  </div>
}
@if (currentView !== MigrationCustomerView.VIEW) {
  <iwt-estatecloud-migration-edit-customer
    [customer]="customerEditItem"
    (changeMigrationCustomerEvent)="changedMigrationCustomer($event)"
  />
}
